const url = process.env.NODE_ENV === 'production' ? 'https://visa-application-form.sport-syy.com/ApplicantsOrder' : 'https://test-visa-application-form.sport-syy.com/ApplicantsOrder';
const visaUrl = process.env.NODE_ENV === 'production' ? 'https://visa-application-form.sport-syy.com' : 'https://test-visa-application-form.sport-syy.com';
export const getEnvModelUrl = () => {
  return url
}
export const getEnvModelUrlVisa=()=>{
  return visaUrl
}
 